import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  row: {
    display: "flex",
    alignItems: "flex-end",
    flexDirection: "row",
  },
  dateRangeInput: {
    minWidth: "150px",
    paddingLeft: "10px",
  },
  paddingLeft: {
    paddingLeft: "10px",
  },
}));

export default styles;
